<div class="modal-header mainColor">
    <h6 class="modal-title">{{"action_plan.plan_development.historic" | translate}}</h6>
    <button type="button" class="close dangerButton" aria-label="Close" style="opacity: 1;" (click)="btnDismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <app-historic-details [returnToActive]='return' (emitReturn)="returnToActives()" [planSelected]="data">
    </app-historic-details>
</div>
<div class="modal-footer">

    <button type="button" ngbAutofocus class="btn mainColor text-white" (click)="returnToActives()">
        <ng-container *ngIf="!return;else spinner">
            {{"action_plan.plan_development.modal_reactivate.reactivate" | translate}}
        </ng-container>


        <ng-template #spinner>
            <fa-icon icon="spinner" [spin]="true"></fa-icon>
        </ng-template>
    </button>

    <!-- <button type="button" ngbAutofocus class="btn acceptButton" (click)="btnClose()">{{"globals.buttons.accept" |
        translate}}</button> -->
</div>